import { sendEvent } from "@app/utils/tracking/Tracker";

// Sharing
export const shareReportClick = sendEvent("share_report_click");
export const shareReportAddPeople = sendEvent<{ count: number }>(
  "share_report_add_people"
);
export const shareReportCopyLink = sendEvent("share_report_copy_link");

export const shareReportSuccess = sendEvent<{
  type: "meeting" | "topic";
  channel_provider?: string;
}>("share_report_success");
export const shareReportDone = sendEvent("share_report_done");
